import { useTokenStore } from "../storage/tokenState";
import { queryClient } from '../App';
import { USER_TOKEN } from "../appConstants/AppConstant";

/**
 * Reset all stores and clear authentication data
 * This properly logs out the user by clearing token from both store and localStorage
 */
export const resetAllStores = () => {
  // Step 1: Remove the specific token key from localStorage FIRST
  // This prevents Zustand's persist middleware from rehydrating the token
  localStorage.removeItem(USER_TOKEN);
  
  // Step 2: Reset Zustand store state to initial values
  const resetAuthStore = useTokenStore.getState().resetTokenStore;
  resetAuthStore();
  
  // Step 3: Clear React Query cache
  queryClient?.clear();
  
  console.log('[RESET-STORES] All stores reset and USER_TOKEN removed from localStorage');
};
